export const MENTOR_POPUP_OPEN: string = 'MENTOR_POPUP_OPEN'
export const MENTOR_POPUP_CLOSE: string = 'MENTOR_POPUP_CLOSE'
